module.exports = __webpack_public_path__ + "img/card-f.71cbd21d.png";